import { render, staticRenderFns } from "./ShareFat.vue?vue&type=template&id=5f3351be"
import script from "./ShareFat.vue?vue&type=script&lang=js"
export * from "./ShareFat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports